import { LOSS_TYPE_KEYS, DOC_FIELD_MAP, rawDigits } from './intakeConstants';

/** Build the JSON payload posted to POST /api/claims from form state. */
export function buildClaimPayload(formData, companies, activeOrgId) {
  const docBooleans = {};
  Object.entries(DOC_FIELD_MAP).forEach(([label, field]) => {
    docBooleans[field] = formData.selectedDocuments.includes(label);
  });

  const selectedCompany = companies.find((c) => c.name === formData.company);
  const claimOrgId = selectedCompany?.org_id || activeOrgId || null;

  return {
    company_name: formData.company,
    org_id: claimOrgId,
    date_of_loss: formData.dateOfLoss || null,
    drivers_name: formData.driverName || null,
    drivers_ph_no: rawDigits(formData.driverPhone) || null,
    truck_no: formData.truckNumber || null,
    trailer_no: formData.trailerNumber || null,
    location: formData.location || null,
    description: formData.lossDescription || null,
    fault: formData.faultOfDriver || null,
    police_involved:
      formData.policeInvolved === 'Yes' ? true : formData.policeInvolved === 'No' ? false : null,
    citation: formData.policeInvolved === 'Yes' ? formData.citationIssued : null,
    police_report_no: formData.policeInvolved === 'Yes' ? formData.policeReportNo : null,
    police_report_not_ready:
      formData.policeInvolved === 'Yes' ? formData.policeReportNotReady : false,
    other_vehicle_involved: formData.otherVehicle || null,
    tow_away: formData.towAway || false,
    injury: formData.injury || false,
    fatality: formData.fatality || false,
    al: formData.lossTypes.includes('Auto Liability'),
    pd: formData.lossTypes.includes('Physical Damage'),
    cd: formData.lossTypes.includes('Cargo Damage'),
    ocac: formData.lossTypes.includes('Occupational Accident'),
    wc: formData.lossTypes.includes('Workers Compensation'),
    type_data: Object.fromEntries(
      LOSS_TYPE_KEYS.filter(([, label]) => formData.lossTypes.includes(label)).map(([key]) => [
        key,
        { submittal: 'Pending', status: 'New' },
      ]),
    ),
    selected_documents: formData.selectedDocuments,
    ...docBooleans,
  };
}
